<template>
	<div class="manage">
		<div class="top" style="margin: 0px;">


			<!-- 订单列表 -->
			<el-row v-if="!showDetail">
				<el-col :span="24" class="table" style="margin: 0px;">
					<div ref="height_top" class="order-card-container"
						:style="{ height: tableHeight - 20 + 'px', overflowY: 'auto' }">

						<div v-loading="loading" class="order-card-list">

							<div v-for="order in tableData" :key="order.key" class="order-card"
								@dblclick="handleCardDblclick(order)">
								<div class="card-header">
									<el-row>
										<el-col :span="6">
											<div class="header-item">
												<span class="item-label">订单日期</span>
												<span class="item-value">{{ order.create_time }}</span>
											</div>
										</el-col>
										<el-col :span="6">
											<div class="header-item">
												<span class="item-label">订单号</span>
												<span class="item-value order-no">{{ order.pay_no }}</span>
											</div>
										</el-col>
										<el-col :span="4">
											<div class="header-item">
												<span class="item-label">快递单号</span>
												<span class="item-value"
													v-if="order.express_company && order.express_code">{{
														order.express_company }}:{{ order.express_code }}</span>
												<span class="item-value" v-else>-</span>
											</div>
										</el-col>
										<el-col :span="5" style="display: flex; align-items: center;">
											<div class="confirm-tip" v-if="order.state === 3">
												<el-icon>
													<Clock />
												</el-icon>
												订单正在确认中，商家确认后可进行支付！
											</div>

											<div class="confirm-tip"
												v-else-if="order.state === 0 && order.card_state !== 1">
												<el-icon>
													<Clock />
												</el-icon>
												商家已确认订单，可进行支付！
											</div>
										</el-col>
										<el-col :span="3" style="display: flex;">
											<div class="info-item status-info-item"
												style="display: flex; width: 100%;justify-content: end;align-items: center;gap: 4px;padding: 0.3125rem 0.3875rem;">
												<el-tooltip v-if="order.state === -1 && order.cancel_uid === 0"
													:content="order.cancel_remark || '暂无原因'" placement="top">
													<el-icon class="cancel-reason-icon">
														<QuestionFilled />
													</el-icon>
												</el-tooltip>
												<el-tag :type="getStatusType(order)" style="" class="status-tag"
													size="default">{{
														getStatusText(order) }}</el-tag>

											</div>
										</el-col>
									</el-row>




								</div>
								<div class="card-body">
									<div class="body-left">
										<div class="info-row">
											<el-row>
												<el-col :span="6">
													<el-row>
														<el-col :span="12">
															<div class="info-item">
																<span class="info-label">商品数量</span>
																<span class="info-value">{{ order.total_num || 0 }}
																</span>
															</div>
														</el-col>
														<el-col :span="12">
															<div class="info-item">
																<span class="info-label">商品金额</span>
																<span class="info-value price">¥{{
																	order.total_goods_money
																}}</span>
															</div>
														</el-col>
													</el-row>


												</el-col>
												<el-col :span="6">
													<el-row>
														<el-col :span="12">
															<div class="info-item"
																v-if="Number(order.goods_discount) > 0">
																<span class="info-label">优惠金额</span>
																<span class="info-value discount">
																	<el-tag type="danger" size="small"
																		effect="dark">省</el-tag>
																	¥{{ order.goods_discount || '0.00' }}
																</span>
															</div>
														</el-col>
														<el-col :span="12">
															<div class="info-item">
																<span class="info-label">运费</span>
																<span class="info-value price">¥{{ order.freight_fee ||
																	'0.00'
																}}</span>
															</div>
														</el-col>
													</el-row>


												</el-col>
												<el-col :span="4">
													<div class="info-item">
														<span class="info-label">订单金额</span>
														<span class="info-value price">¥{{ order.total_order_money ||
															'0.00' }}</span>
													</div>
												</el-col>
												<el-col :span="8">
													<div class="body-right"
														style="display: flex; justify-content: flex-end; align-items: center; height: 100%; width: 100%;">

														<div class="button-group">
															<el-button v-if="order.htfilepath" size="small"
																@click="handleDownloadContract(order)">下载订单</el-button>
															<!-- 其他状态的按钮 -->

															<el-button v-if="order.state === 0 || order.state === 3"
																type="danger" size="small"
																@click="handleCancelOrder(order)" plain>取消订单</el-button>

															<el-button v-if="order.state === 4 || order.state === -1"
																size="small"
																@click="handleReorder(order)">再次下单</el-button>
															<el-button v-if="order.state === 2" size="small"
																@click="handleConfirmReceipt(order)">确认收货</el-button>
															<el-button
																v-if="order.state === 0 && !(order.state === 0 && order.card_state === 1)"
																type="primary" size="small" text
																@click="goToPay(order)">去 支
																付</el-button>

															<el-button type="danger" size="small"
																v-if="order.state === -1"
																@click="handleDeleteOrder(order)" plain>删除订单</el-button>
															<!-- 发票相关按钮 -->
															<el-button
																v-if="order.state === 4 && order.invoice_status === 2 && order.user_type === 1"
																type="success" size="small" plain
																@click="handleViewInvoiceFile(order)">查看发票</el-button>
															<el-button
																v-else-if="order.state === 4 && order.invoice_status === 1"
																type="success" size="small" plain
																@click="handleViewInvoiceInfo(order)">开 票
																中</el-button>
															<el-button
																v-else-if="order.state === 4 && order.invoice_status === 2"
																type="success" size="small" plain
																@click="handleViewInvoiceFile(order)">查看发票</el-button>

															<el-tooltip
																v-else-if="order.state === 4 && (!order.invoice_status || order.invoice_status === 3) && (Number(order.total_order_money) || 0) - (Number(order.total_refund_money) || 0) <= 0"
																content="可开票金额为0，暂不可开票" placement="top">
																<el-button type="info" size="small" plain
																	disabled>申请开票</el-button>
															</el-tooltip>
															<el-button
																v-else-if="order.state === 4 && (!order.invoice_status || order.invoice_status === 3) && (Number(order.total_order_money) || 0) - (Number(order.total_refund_money) || 0) > 0"
																type="success" size="small" plain
																@click="handleApplyInvoice(order)">申请开票</el-button>
															<!-- 下载合同按钮 -->



															<!-- 查看详情按钮 -->
															<el-button
																v-if="order.state !== 0 || (order.state === 0 && order.card_state === 1)"
																type="primary" size="small" text
																@click="viewDetail(order)">查看详情</el-button>

															<!-- 删除订单按钮 -->

														</div>
													</div>
												</el-col>

											</el-row>




										</div>
									</div>

								</div>
							</div>
							<div v-if="tableData.length === 0" :style="{ height: tableHeight - 20 + 'px' }">
								<el-empty description="暂无数据" :image-size="120">
									<template #description>
										<div class="empty-title">暂无数据</div>
										<div class="empty-subtitle"></div>
									</template>
								</el-empty>

							</div>

						</div>
					</div>
				</el-col>
				<el-col :span="24" class="page" style="display: flex; justify-content: flex-end;">
					<el-pagination :pager-count="5" size="small" class="pagination" :current-page="page" background
						:page-size="parseInt(page_size)" layout="prev, pager, next"
						@current-change="handleCurrentChange" :total="total">
					</el-pagination>
				</el-col>
			</el-row>

			<!-- 订单详情 -->
			<el-row v-else>
				<el-col :span="24">
					<div class="detail-header">
						<el-button type="primary" size="small" text @click="backToList">
							<el-icon>
								<ArrowLeft />
							</el-icon> 返回列表
						</el-button>
					</div>
					<div class="order-detail-page" ref="detailRef">
						<div class="order-container scroll-container" :style="{ height: (tableHeight) + 'px' }"
							style="overflow: auto;" v-loading="loading">
							<!-- 订单流程 -->
							<div class="order-section order-progress-section">
								<div class="progress-steps">
									<el-steps :space="200" :active="currentStepIndex" finish-status="success"
										align-center>
										<el-step>
											<template #icon>
												<div class="step-icon-wrapper create-icon">
													<el-icon>
														<DocumentAdd />
													</el-icon>
												</div>
											</template>
											<template #title>
												<span class="step-title">创建订单</span>
											</template>
											<template #description>
												<span class="step-time">{{ currentOrder.create_time || '--' }}</span>
											</template>
										</el-step>
										<el-step>
											<template #icon>
												<div class="step-icon-wrapper confirm-icon">
													<el-icon>
														<Checked />
													</el-icon>
												</div>
											</template>
											<template #title>
												<span class="step-title">商家确认</span>
											</template>
											<template #description>
												<span class="step-time">{{ currentOrder.create_time || '--' }}</span>
											</template>
										</el-step>
										<el-step>
											<template #icon>
												<div class="step-icon-wrapper pay-icon">
													<el-icon>
														<Wallet />
													</el-icon>
												</div>
											</template>
											<template #title>
												<span class="step-title">待支付</span>
											</template>
											<template #description>
												<span class="step-time">{{ currentOrder.affirm_time || '--' }}</span>
											</template>
										</el-step>
										<el-step>
											<template #icon>
												<div class="step-icon-wrapper ship-icon">
													<el-icon>
														<Box />
													</el-icon>
												</div>
											</template>
											<template #title>
												<span class="step-title">待发货</span>
											</template>
											<template #description>
												<span class="step-time">{{ currentOrder.confirm_time || '--' }}</span>
											</template>
										</el-step>
										<el-step>
											<template #icon>
												<div class="step-icon-wrapper receive-icon">
													<el-icon>
														<Van />
													</el-icon>
												</div>
											</template>
											<template #title>
												<span class="step-title">待收货</span>
											</template>
											<template #description>
												<span class="step-time">{{ currentOrder.express_time || '--' }}</span>
											</template>
										</el-step>
										<el-step>
											<template #icon>
												<div class="step-icon-wrapper complete-icon">
													<el-icon>
														<CircleCheckFilled />
													</el-icon>
												</div>
											</template>
											<template #title>
												<span class="step-title">已完成</span>
											</template>
											<template #description>
												<span class="step-time">{{ currentOrder.receipt_time || '--' }}</span>
											</template>
										</el-step>
									</el-steps>
								</div>
							</div>

							<!-- 物流信息 -->
							<div class="order-section">
								<div class="section-title">物流信息</div>
								<div class="logistics-timeline">
									<el-timeline>
										<!-- 物流动态 -->
										<el-timeline-item v-for="(item, index) in logisticsList" :key="index"
											:timestamp="item.time" placement="top"
											:type="index === 0 ? 'success' : 'primary'"
											:color="index === 0 ? '#67c23a' : '#ff8a5c'" size="large">
											<div>
												<div style="font-weight: 500; margin-bottom: 4px;">{{ item.context }}
												</div>
												<div v-if="item.areaName" style="color: #999; font-size: 12px;">{{
													item.areaName }}
												</div>
												<div v-if="item.status"
													style="color: #67c23a; font-size: 12px; margin-top: 4px;">{{
														item.status }}</div>
											</div>
										</el-timeline-item>

									</el-timeline>
									<div class="ship-info">

										<div class="ship-detail">
											<div class="detail-item">
												<span class="detail-label">快递公司：</span>
												<span class="detail-value">{{ currentOrder.expressCompany ||
													currentOrder.express_company || '-' }}</span>
											</div>
											<div class="detail-item">
												<span class="detail-label">快递单号：</span>
												<span class="detail-value">{{ currentOrder.expressCode ||
													currentOrder.express_code
													|| '-' }}</span>
											</div>
											<div class="detail-item">
												<span class="detail-label">收货人：</span>
												<span class="detail-value">{{ currentOrder.linkman ||
													(currentOrder.address &&
														currentOrder.address.name) || '-' }}</span>
											</div>
											<div class="detail-item">
												<span class="detail-label">收货电话：</span>
												<span class="detail-value">{{ currentOrder.phone ||
													(currentOrder.address &&
														currentOrder.address.phone) || '-' }}</span>
											</div>
											<div class="detail-item full-width">
												<span class="detail-label">收货地址：</span>
												<span class="detail-value">{{
													(currentOrder.province
														+ currentOrder.city + currentOrder.district +
														currentOrder.address) }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- 订单信息 -->
							<div class="order-section">
								<div class="section-title">订单信息</div>
								<div class="order-info">
									<div class="info-item">
										<span class="info-label">订单号：</span>
										<span class="info-value">{{ currentOrder.pay_no }}</span>
									</div>
									<div class="info-item">
										<span class="info-label">订单状态：</span>
										<el-tooltip v-if="currentOrder.state === -1 && currentOrder.cancel_uid === 0"
											:content="currentOrder.cancel_remark || '暂无原因'" placement="top">
											<el-tag :type="getStatusType(currentOrder)" style="width: max-content;">{{
												getStatusText(currentOrder)
											}}</el-tag>
										</el-tooltip>
										<el-tag v-else :type="getStatusType(currentOrder)"
											style="width: max-content;">{{
												getStatusText(currentOrder)
											}}</el-tag>
									</div>
									<div class="info-item">
										<span class="info-label">创建时间：</span>
										<span>{{ currentOrder.create_time }}</span>
									</div>
									<div class="info-item"
										v-if="currentOrder.pay_type && currentOrder.state !== 3 && currentOrder.state !== 0">
										<span class="info-label">支付方式：</span>
										<span>{{ getPaymentMethodText(currentOrder.pay_type) }}</span>
									</div>
									<div class="info-item" v-if="currentOrder.freight_type">
										<span class="info-label">配送方式：</span>
										<span>{{ getFreightTypeText(currentOrder.freight_type) }}</span>
									</div>
								</div>
							</div>
							<!-- 对公账户信息 + 付款信息 公用一个背景框 -->
							<div class="order-section" v-if="currentOrder.pay_type == 3">
								<div class="order-section-row">
									<div class="order-section-col">
										<div class="section-title">对公账户信息</div>
										<div class="order-info">
											<div class="info-item">
												<span class="info-label">开户银行：</span>
												<span class="info-value">{{ currentOrder.open_bank }}</span>
											</div>
											<div class="info-item">
												<span class="info-label">账户名称：</span>
												<span class="info-value">{{ currentOrder.bank_name }}</span>
											</div>
											<div class="info-item">
												<span class="info-label">银行账号：</span>
												<span class="info-value">{{ currentOrder.bank_no }}</span>
											</div>
										</div>
									</div>
									<div class="order-section-col">
										<div class="section-title">付款信息</div>
										<div class="order-info">
											<div class="info-item">
												<span class="info-label">付款公司名称：</span>
												<span class="info-value">{{ currentOrder.pay_company_name }}</span>
											</div>
											<div class="info-item">
												<span class="info-label">付款金额：</span>
												<span class="info-value">{{ currentOrder.pay_amount }}</span>
											</div>
											<div class="info-item voucher-info-item">
												<span class="info-label">付款凭证：</span>
												<div class="voucher-list" v-if="voucherImages.length > 0">
													<el-image v-for="(img, index) in voucherImages" :key="index"
														:src="img" fit="cover" :preview-src-list="voucherImages"
														:initial-index="index" preview-teleported class="voucher-img" />
												</div>
												<span class="info-value" v-else>-</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- 收货地址 -->
							<!-- <div class="order-section" v-if="currentOrder.address">
								<div class="section-title">收货地址</div>
								<div class="address-section">
									<div class="address-item">
										<div class="address-info">
											<span class="address-name">{{ currentOrder.address.name }}</span>
											<span class="address-phone">{{ currentOrder.address.phone }}</span>
										</div>
										<div class="address-detail">{{ currentOrder.address.province }}{{
											currentOrder.address.city
										}}{{ currentOrder.address.district }}{{ currentOrder.address.detail }}</div>
									</div>
								</div>
							</div> -->

							<!-- 购买清单 -->
							<div class="order-section">
								<div class="section-title">购买清单</div>
								<div class="purchase-list">
									<div>
										<el-table :data="currentOrder.product"
											:header-cell-style="{ 'background-color': '#e5e5e5' }" size="small"
											style="width: 100%;">
											<el-table-column prop="img" label="实图" width="100" header-align="center"
												show-overflow-tooltip>
												<template #default="scope">
													<div v-if="!scope.row.img || scope.row.img.length <= 0">
														<div @click="preview(scope.row, scope.row.img)">
															<el-image :src="require('@/assets/img/error_img.png')"
																loading="lazy" />
														</div>
													</div>
													<div v-else>
														<div @click="preview(scope.row, scope.row.img)">
															<el-image :src="scope.row.img[0]" loading="lazy" />
														</div>
													</div>
												</template>
											</el-table-column>
											<el-table-column prop="stock_type_txt" label="货物状态" header-align="center"
												width="200" show-overflow-tooltip>
												<template #default="scope">
													<div class="stock_type_txt_button">
														<span v-for="(item, idx) in scope.row.stock_type_txt_list"
															:key="idx">
															<el-button class="A" size="small" text bg
																v-if="item == '二手' || item == '过保' || item == '包附破损'"
																style="">{{ item }}</el-button>
															<el-button class="C" size="small" text bg v-else
																color="#ff8a5c">{{ item }}</el-button>
														</span>
													</div>
												</template>
											</el-table-column>
											<el-table-column prop="brand_name" label="产品信息" show-overflow-tooltip>
												<template #default="scope">
													<div class="product-info">
														<div class="brand-name" v-if="scope.row.product_brand_name">
															{{ scope.row.product_brand_name }}
														</div>
														<div class="product-name" v-if="scope.row.product_name">
															{{ scope.row.product_name }}
														</div>
														<div class="product-details" v-if="scope.row.product_model">
															<span class="detail-label">型号</span><span
																class="label-colon">：</span>
															<span class="detail-value">{{ scope.row.product_model
															}}</span>
														</div>
														<div class="product-details" v-if="scope.row.product_order_no">
															<span class="detail-label">订货号</span><span
																class="label-colon">：</span>
															<span class="detail-value">{{ scope.row.product_order_no
															}}</span>
														</div>
														<div class="product-details">
															<span class="detail-label">单位</span><span
																class="label-colon">：</span>
															<span class="detail-value">{{ scope.row.product_unit
															}}</span>
														</div>

														<span
															v-if="!scope.row.product_brand_name && !scope.row.product_name && !scope.row.product_model && !scope.row.product_order_no">
															-
														</span>

													</div>
												</template>
											</el-table-column>
											<el-table-column prop="tsw_price" align="center" header-align="center"
												label="单价" width="120" show-overflow-tooltip>
												<template #default="scope">
													<span class="price-value">{{ scope.row.price }}</span>
												</template>
											</el-table-column>
											<el-table-column prop="num" label="数量" width="100" align="center"
												header-align="center">
												<template #default="scope">
													<span>{{ scope.row.num }}</span>
												</template>
											</el-table-column>
											<el-table-column prop="tsw_money" align="center" header-align="center"
												label="金额" width="120" show-overflow-tooltip>
												<template #default="scope">
													<span class="price-value">{{ scope.row.sum }}</span>
												</template>
											</el-table-column>
										</el-table>
									</div>
								</div>
							</div>

							<!-- 订单备注 -->
							<div class="order-section" v-if="currentOrder.remark">
								<div class="section-title">订单备注</div>
								<div class="remark-section">
									<div class="remark-content">{{ currentOrder.remark }}</div>
								</div>
							</div>

							<!-- 订单详情 -->
							<div class="order-section">
								<div class="section-title">订单详情</div>
								<div class="order-summary">
									<div class="summary-item">
										<span class="summary-label">商品数量：</span>
										<span class="summary-value">{{ currentOrder.total_num }} 件</span>
									</div>
									<div class="summary-item" v-if="currentOrder.freight_fee !== undefined">
										<span class="summary-label">快递费用：</span>
										<span class="summary-value">¥{{ currentOrder.freight_fee }}</span>
									</div>
									<div class="summary-item">
										<span class="summary-label">商品金额：</span>
										<span class="summary-value">¥{{ currentOrder.total_goods_money }}</span>
									</div>
									<div class="summary-item" v-if="Number(currentOrder.goods_discount) > 0">
										<span class="summary-label">优惠金额：</span>
										<span class="summary-value discount">
											<el-tag type="danger" size="small" effect="dark">省</el-tag>
											¥{{ currentOrder.goods_discount }}
										</span>
									</div>
									<div class="summary-divider"></div>
									<div class="summary-item total-item">
										<span class="summary-label">合计：</span>
										<span class="summary-value total-value">¥{{ currentOrder.total_order_money
										}}</span>
									</div>
								</div>
							</div>
							<!-- 底部固定栏 -->
							<div class="order-detail-footer">
								<div class="footer-left">
									<div class="total-info">
										<span class="total-label">商品数量：</span>
										<span class="total-value">{{ currentOrder.total_num || 0 }} 件</span>
									</div>
									<div class="total-info">
										<span class="total-label">订单金额：</span>
										<span class="total-amount">¥{{ currentOrder.total_order_money || '0.00'
										}}</span>
									</div>
									<div class="total-info" v-if="currentOrder.total_refund_money > 0">
										<span class="total-label">退货金额：</span>
										<span class="total-amount">¥{{ currentOrder.total_refund_money || '0.00'
										}}</span>
									</div>
								</div>
								<div class="footer-right">
									<!-- 待收货状态 - 显示倒计时和按钮 -->
									<template v-if="currentOrder.state === 2 || currentOrder.state === 4">
										<div class="countdown-wrapper" v-if="currentOrder.state === 2">
											<el-icon>
												<Clock />
											</el-icon>
											<span class="countdown-text">自动确认收货倒计时：{{ getCountdownText(currentOrder)
											}}</span>
										</div>
										<el-button type="primary" size="small" v-if="currentOrder.state === 2"
											@click="handleConfirmReceipt(currentOrder)">确认收货</el-button>
										<el-button type="warning" size="small"
											@click="handleApplyAfterSales(currentOrder)">申请售后</el-button>
									</template>
									<!-- 其他状态 -->
									<el-button type="primary" size="small"
										v-if="currentOrder.state === 0 && currentOrder.card_state === 1"
										@click="goToPay(currentOrder)">重新支付</el-button>
									<el-button class="delete-btn" size="small" v-if="currentOrder.state === -1"
										@click="handleDeleteOrder(currentOrder)">删除订单</el-button>
								</div>
							</div>

						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
	<examineImg ref="examineImg"></examineImg>

	<!-- 申请售后弹窗 -->
	<afterSales v-model:visible="afterSalesVisible" :order="currentOrder" @apply="handleAfterSalesSuccess"></afterSales>

	<!-- 申请开票弹窗 -->
	<el-dialog v-model="invoiceDialogVisible" :title="invoiceFailReason ? '重新申请开票' : '申请开票'" width="40%"
		:close-on-click-modal="false">

		<!-- 金额信息 -->
		<el-descriptions :column="1" border style="margin-bottom: 20px;">
			<el-descriptions-item label="订单金额">
				<span class="price">¥{{ (Number(currentInvoiceInfo.total_order_money) || 0).toFixed(2) }}</span>
			</el-descriptions-item>
			<el-descriptions-item label="退款金额">
				<span class="discount">¥{{ (Number(currentInvoiceInfo.total_refund_money) || 0).toFixed(2) }}</span>
			</el-descriptions-item>
			<el-descriptions-item label="可开票金额">
				<span class="price" style="color: #67c23a; font-weight: bold;">¥{{
					(Number(currentInvoiceInfo.total_order_money) || 0) - (Number(currentInvoiceInfo.total_refund_money)
						||
						0) >= 0 ? ((Number(currentInvoiceInfo.total_order_money) || 0) -
							(Number(currentInvoiceInfo.total_refund_money) || 0)).toFixed(2) : '0.00' }}</span>
			</el-descriptions-item>
		</el-descriptions>

		<!-- 开票失败原因提示 -->
		<el-alert v-if="invoiceFailReason" :title="'上次开票失败原因：' + invoiceFailReason" type="error" :closable="false"
			style="margin-bottom: 20px;"></el-alert>
		<el-form :model="invoiceForm" label-width="100px" ref="invoiceFormRef">

			<el-form-item label="发票类型" required>
				<el-radio-group v-model="invoiceForm.invoice_type">
					<el-radio label="1">增值税普通发票</el-radio>
					<el-radio label="2">增值税专用发票</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="发票抬头" required>
				<el-select v-model="invoiceForm.invoice_title" filterable allow-create placeholder="请选择或输入发票抬头"
					style="width: 100%;">
					<el-option v-for="(item, index) in invoiceHistoryList" :key="index" :label="item.invoice_title"
						:value="item.invoice_title" @click="selectInvoiceHistory(item)"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="公司税号" required v-if="invoiceForm.invoice_type === '2'">
				<el-input v-model="invoiceForm.tax_number" placeholder="请输入公司税号"></el-input>
			</el-form-item>
			<el-form-item label="联系电话">
				<el-input v-model="invoiceForm.phone" placeholder="请输入联系电话"></el-input>
			</el-form-item>
			<el-form-item label="联系地址" v-if="invoiceForm.invoice_type === '2'">
				<el-input v-model="invoiceForm.address" placeholder="请输入联系地址"></el-input>
			</el-form-item>
			<el-form-item label="开户银行" v-if="invoiceForm.invoice_type === '2'">
				<el-input v-model="invoiceForm.bank_name" placeholder="请输入开户银行"></el-input>
			</el-form-item>
			<el-form-item label="银行账号" v-if="invoiceForm.invoice_type === '2'">
				<el-input v-model="invoiceForm.bank_account" placeholder="请输入银行账号"></el-input>
			</el-form-item>
		</el-form>
		<template #footer>
			<el-button @click="invoiceDialogVisible = false">取消</el-button>
			<el-button type="primary" @click="submitInvoice" :loading="invoiceSubmitting">提交</el-button>
		</template>
	</el-dialog>

	<!-- 查看开票信息弹窗 -->
	<el-dialog v-model="invoiceInfoDialogVisible" title="开票信息" width="500px">
		<el-descriptions :column="1" border>
			<el-descriptions-item label="订单金额">
				<span class="price">¥{{ (Number(currentInvoiceInfo.total_order_money) || 0).toFixed(2) }}</span>
			</el-descriptions-item>
			<el-descriptions-item label="退款金额">
				<span class="discount">¥{{ (Number(currentInvoiceInfo.total_refund_money) || 0).toFixed(2) }}</span>
			</el-descriptions-item>
			<el-descriptions-item label="可开票金额">
				<span class="price" style="color: #67c23a; font-weight: bold;">¥{{
					(Number(currentInvoiceInfo.total_order_money) || 0) - (Number(currentInvoiceInfo.total_refund_money)
						||
						0) >= 0 ? ((Number(currentInvoiceInfo.total_order_money) || 0) -
							(Number(currentInvoiceInfo.total_refund_money) || 0)).toFixed(2) : '0.00' }}</span>
			</el-descriptions-item>
			<el-descriptions-item label="发票类型">{{ currentInvoiceInfo.invoice_type === '1' ? '增值税普通发票' : '增值税专用发票'
			}}</el-descriptions-item>
			<el-descriptions-item label="发票抬头">{{ currentInvoiceInfo.invoice_title }}</el-descriptions-item>
			<el-descriptions-item label="公司税号" v-if="currentInvoiceInfo.tax_number">{{ currentInvoiceInfo.tax_number
			}}</el-descriptions-item>
			<el-descriptions-item label="联系电话" v-if="currentInvoiceInfo.phone">{{ currentInvoiceInfo.phone
			}}</el-descriptions-item>
			<el-descriptions-item label="联系地址" v-if="currentInvoiceInfo.address">{{ currentInvoiceInfo.address
			}}</el-descriptions-item>
			<el-descriptions-item label="开户银行" v-if="currentInvoiceInfo.bank_name">{{ currentInvoiceInfo.bank_name
			}}</el-descriptions-item>
			<el-descriptions-item label="银行账号" v-if="currentInvoiceInfo.bank_account">{{ currentInvoiceInfo.bank_account
			}}</el-descriptions-item>
		</el-descriptions>
		<template #footer>
			<el-button @click="invoiceInfoDialogVisible = false">关闭</el-button>
		</template>
	</el-dialog>

	<!-- 查看发票文件弹窗 -->
	<el-dialog v-model="invoiceFileDialogVisible" title="查看发票" width="600px">
		<el-descriptions :column="1" border>
			<el-descriptions-item label="订单金额">
				<span class="price">¥{{ (Number(currentInvoiceInfo.total_order_money) || 0).toFixed(2) }}</span>
			</el-descriptions-item>
			<el-descriptions-item label="退款金额">
				<span class="discount">¥{{ (Number(currentInvoiceInfo.total_refund_money) || 0).toFixed(2) }}</span>
			</el-descriptions-item>
			<el-descriptions-item label="可开票金额">
				<span class="price" style="color: #67c23a; font-weight: bold;">¥{{
					(Number(currentInvoiceInfo.total_order_money) || 0) - (Number(currentInvoiceInfo.total_refund_money)
						||
						0) >= 0 ? ((Number(currentInvoiceInfo.total_order_money) || 0) -
							(Number(currentInvoiceInfo.total_refund_money) || 0)).toFixed(2) : '0.00' }}</span>
			</el-descriptions-item>
			<el-descriptions-item label="发票类型">{{ currentInvoiceInfo.invoice_type === '1' ? '增值税普通发票' : '增值税专用发票'
			}}</el-descriptions-item>
			<el-descriptions-item label="发票抬头">{{ currentInvoiceInfo.invoice_title }}</el-descriptions-item>
			<el-descriptions-item label="公司税号" v-if="currentInvoiceInfo.tax_number">{{ currentInvoiceInfo.tax_number
			}}</el-descriptions-item>
			<el-descriptions-item label="联系电话" v-if="currentInvoiceInfo.phone">{{ currentInvoiceInfo.phone
			}}</el-descriptions-item>
			<el-descriptions-item label="联系地址" v-if="currentInvoiceInfo.address">{{ currentInvoiceInfo.address
			}}</el-descriptions-item>
			<el-descriptions-item label="开户银行" v-if="currentInvoiceInfo.bank_name">{{ currentInvoiceInfo.bank_name
			}}</el-descriptions-item>
			<el-descriptions-item label="银行账号" v-if="currentInvoiceInfo.bank_account">{{ currentInvoiceInfo.bank_account
			}}</el-descriptions-item>
			<el-descriptions-item label="开票日期">{{ currentInvoiceInfo.invoice_date
			}}</el-descriptions-item>
			<el-descriptions-item label="发票号码">{{ currentInvoiceInfo.invoice_number
			}}</el-descriptions-item>
			<el-descriptions-item label="开票金额">{{ currentInvoiceInfo.invoice_amount
			}}</el-descriptions-item>
		</el-descriptions>

		<template #footer>
			<el-button @click="invoiceFileDialogVisible = false">关闭</el-button>
			<el-button v-if="currentInvoiceFile" type="primary" @click="downloadInvoiceFile">下载发票</el-button>
		</template>
	</el-dialog>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import {
	ArrowLeft,
	DocumentAdd,
	Wallet,
	Box,
	Van,
	CircleCheckFilled,
	Clock,
	Checked,
	QuestionFilled
} from '@element-plus/icons-vue';
import '../../assets/user/index.css' //优化表格样式
import examineImg from '../public/img';
import afterSales from '../public/afterSales';
export default {
	components: {
		ArrowLeft,
		DocumentAdd,
		Wallet,
		Box,
		Van,
		CircleCheckFilled,
		Clock,
		Checked,
		examineImg,
		afterSales
	},
	emits: ['refresh-order-nums'],
	data() {
		return {
			tableData: [],
			form: {
				name: '',
				userinfo: '',
				type: '',
				status: '',
			},
			loading: false,
			total: 0,
			page: 1,
			tableHeight: 400,
			page_size: 120,
			user_id: '',
			// 倒计时相关
			countdownTimer: null,
			serverTime: null,
			localTimeAtServerTime: null,
			// 订单状态标签页

			showDetail: false,
			currentOrder: {},
			logisticsList: [],
			srcList: [],
			// 申请开票相关
			invoiceDialogVisible: false,
			invoiceSubmitting: false,
			invoiceHistoryList: [],
			invoiceFailReason: '',
			invoiceForm: {
				pay_no: '',
				invoice_type: '1',
				invoice_title: '',
				tax_number: '',
				phone: '',
				address: '',
				bank_name: '',
				bank_account: ''
			},
			// 查看开票信息相关
			invoiceInfoDialogVisible: false,
			currentInvoiceInfo: {},
			// 查看发票文件相关
			invoiceFileDialogVisible: false,
			currentInvoiceFile: '',
			// 申请售后相关
			afterSalesVisible: false
		}
	},
	props: {
		status: {
			type: String,
			default: ''
		}
	},
	mounted() {
		this.search();
		this.tableHeight_fun();
		this.user_id = localStorage.getItem('user_id');
		window.addEventListener('resize', this.tableHeight_fun);
		// 启动倒计时更新定时器
		this.startCountdownTimer();
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.tableHeight_fun);
		// 清除倒计时定时器
		this.stopCountdownTimer();
	},
	created() { },
	computed: {
		currentStepIndex() {
			const stateStepMap = {
				3: 1,
				0: 2,
				1: 3,
				2: 4,
				4: 5
			};
			return stateStepMap[this.currentOrder.state] || 0;
		},
		voucherImages() {
			const order = this.currentOrder || {};
			const raw = order.voucherimgs || order.pay_voucher;
			if (!raw) return [];
			let list = [];
			if (Array.isArray(raw)) {
				list = raw.filter(item => !!item);
			} else if (typeof raw === 'string') {
				try {
					const parsed = JSON.parse(raw);
					if (Array.isArray(parsed)) {
						list = parsed.filter(item => !!item);
					} else {
						list = [raw];
					}
				} catch (e) {
					list = raw.split(',').map(s => s.trim()).filter(s => !!s);
				}
			}
			const base = ((this.$axios && this.$axios.defaults && this.$axios.defaults.baseURL) || '').replace(/\/$/, '');
			return list.map(item => {
				if (/^https?:\/\//.test(item) || item.indexOf('//') === 0) return item;
				return base + '/' + item.replace(/^\//, '');
			});
		}
	},
	watch: {
		status: {
			handler(newVal, oldVal) {
				if (newVal === oldVal) return;
				this.form.status = newVal;
				this.page = 1;
				this.showDetail = false;
				this.search();
			}
		}
	},
	methods: {
		preview(row, img) {
			this.srcList = [];
			var obj = this;
			if (img) {
				img.forEach(function (item) {
					obj.srcList.push(item)
				})
			}
			this.$refs['examineImg'].img_title = row;
			this.$refs['examineImg'].data = this.srcList;
			this.$refs['examineImg'].dialogTableVisible = true;
			this.$refs['examineImg'].imgBigUrl = this.srcList[0];
		},
		async handleDeleteOrder(order) {
			try {
				await ElMessageBox.confirm('确定要删除该订单吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})

				const res = await this.$axios.post('/api/yunsys.Order/deletebills', {
					pay_no: order.pay_no
				})

				const { code, data, msg } = res.data
				if (code === 0) {
					ElMessage.success(msg || '订单已删除')
					this.backToList()
					this.search()
					this.$emit('refresh-order-nums')
				} else {
					ElMessage.error(msg || '删除失败')
				}
			} catch (err) {
				if (err !== 'cancel') {
					console.error('删除订单失败:', err)
					ElMessage.error('系统错误')
				}
			}
		},

		async handleCancelOrder(order) {
			try {
				await ElMessageBox.confirm('确认取消订单吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})

				const res = await this.$axios.post('/api/yunsys.Order/cancelbills', {
					pay_no: order.pay_no
				})

				const data = res.data
				if (data.code === 0) {
					ElMessage.success('取消成功')
					this.search()
					this.$emit('refresh-order-nums')
				} else {
					ElMessage.error(data.msg || '取消失败')
				}
			} catch (err) {
				if (err !== 'cancel') {
					console.error('取消订单失败:', err)
					ElMessage.error('系统错误')
				}
			}
		},
		async handleConfirmReceipt(order) {
			try {
				await ElMessageBox.confirm('确认已收到商品吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})

				const res = await this.$axios.post('/api/yunsys.Order/confirmreceipt', {
					pay_no: order.pay_no
				})

				const data = res.data
				if (data.code === 0) {
					ElMessage.success('确认收货成功')
					this.backToList()
					this.search()
					this.$emit('refresh-order-nums')
				} else {
					ElMessage.error(data.msg || '确认收货失败')
				}
			} catch (err) {
				if (err !== 'cancel') {
					console.error('确认收货失败:', err)
					ElMessage.error('系统错误')
				}
			}
		},
		// 解析时间为秒级时间戳
		parseTimeToSeconds(time) {
			if (typeof time === 'number') {
				return time;
			}
			return Math.floor(new Date(time).getTime() / 1000);
		},
		// 获取当前基于服务器时间的时间
		getCurrentTime() {
			if (!this.serverTime || !this.localTimeAtServerTime) {
				return Math.floor(Date.now() / 1000);
			}
			const localElapsed = Math.floor(Date.now() / 1000) - this.localTimeAtServerTime;
			return this.serverTime + localElapsed;
		},
		// 获取倒计时文本
		getCountdownText(order) {
			// 72小时 = 259200秒
			const TOTAL_TIME = 259200;

			// 如果没有发货时间，返回默认倒计时
			if (!order.express_time) {
				return '72:00:00';
			}

			// 计算已过时间 - 使用服务器时间
			const now = this.getCurrentTime();
			const expressTime = this.parseTimeToSeconds(order.express_time);

			const elapsed = now - expressTime;
			const remaining = Math.max(0, TOTAL_TIME - elapsed);

			// 格式化时间
			const hours = Math.floor(remaining / 3600).toString().padStart(2, '0');
			const minutes = Math.floor((remaining % 3600) / 60).toString().padStart(2, '0');
			const seconds = Math.floor(remaining % 60).toString().padStart(2, '0');

			return `${hours}:${minutes}:${seconds}`;
		},
		// 申请售后
		handleApplyAfterSales(order) {
			this.currentOrder = order;
			this.afterSalesVisible = true;
		},
		// 售后申请成功回调
		async handleAfterSalesSuccess() {
			this.afterSalesVisible = false;
			this.search();
			this.$emit('refresh-order-nums');
		},
		async handleReorder(order) {
			try {
				await ElMessageBox.confirm('确认购买相同商品？', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				});

				// 确认后打开购物车页面并带上订单号参数

				const { href } = this.$router.resolve({
					path: '/user',
					query: { pay_no: order.pay_no, type: 'shopping' }
				});
				window.open(href, '_blank');
			} catch (err) {
				if (err !== 'cancel') {
					console.error('再次下单失败:', err);
					ElMessage.error('系统错误');
				}
			}
		},
		header_table(event) {
			if (event.column.property == 'header') {
				return { 'background-color': '#fff' }
			} else {
				return { 'background-color': '#e5e5e5' }
			}
		},

		getStatusType(order) {
			const state = order.state;
			if (state === 0 && order.card_state === 1) {
				return 'warning';
			}
			const typeMap = {
				0: 'danger',
				1: 'warning',
				2: 'info',
				4: 'success',
				'-1': 'info',
			};
			return typeMap[state] || 'info';
		},
		getStatusText(order) {
			const state = order.state;
			if (state === 0 && order.card_state === 1) {
				return '待支付-等待审核';
			}
			if (state === -1 && order.cancel_uid === 0) {
				return '被取消';
			}
			const textMap = {
				0: '待支付',
				3: '等待商家确认',
				1: '待发货',
				2: '待收货',
				4: '已完成',
				'-1': '已取消',
			};
			return textMap[state] || state;
		},
		async goToPay(order) {
			const { href } = this.$router.resolve({
				path: '/user',
				query: { pay_no: order.pay_no, type: 'order' }
			});
			window.open(href, '_blank');
			try {
				await ElMessageBox.confirm(
					'请在新打开的支付页面完成支付，支付完成后请确认支付状态。',
					'支付确认',
					{
						confirmButtonText: '支付成功',
						cancelButtonText: '支付遇到问题',
						type: 'info',
						distinguishCancelAndClose: true
					}
				);

				// 用户点击支付成功
				ElMessage.success('支付成功！');
				this.$router.go(0); // 刷新当前页面
			} catch (action) {
				if (action === 'cancel') {
					// 用户点击支付遇到问题
					ElMessage.warning('支付遇到问题，您可以稍后重试');
				} else {
					// 用户关闭对话框
					ElMessage.info('您可以稍后在订单中心查看订单状态');
				}
			}
		},
		handleCardDblclick(order) {
			if (order.state === 0 && !(order.state === 0 && order.card_state === 1)) {
				this.goToPay(order);
			} else {
				this.viewDetail(order);
			}
		},
		async viewDetail(order) {
			this.loading = true;
			try {
				const res = await this.$axios.post('/api/yunsys.Order/getdetails', { pay_no: order.pay_no });
				const data = res.data;

				if (data.code !== 0) {
					ElMessage.error(data.msg || '获取订单详情失败');
					return;
				}

				this.currentOrder = data.data;
				if (this.currentOrder.product && this.currentOrder.product.forEach) {
					this.currentOrder.product.forEach(item => {
						item.stock_type_txt_list = item.stock_type_txt ? item.stock_type_txt.split("、") : [];
					});
				}

				// 获取物流详情
				if (this.currentOrder.express_code) {
					await this.fetchLogisticsDetail(order.pay_no);
				} else {
					this.logisticsList = [];
				}

				this.showDetail = true;
			} catch (err) {
				console.error('获取订单详情失败:', err);
				ElMessage.error('系统错误');
			} finally {
				this.loading = false;
			}
		},
		async fetchLogisticsDetail(pay_no) {
			try {
				const res = await this.$axios.post('/api/yunsys.Order/getstagelogict', { pay_no: pay_no });
				const data = res.data;
				console.log(data)
				if (data.code === 0 && data.data.data) {
					this.logisticsList = data.data.data;
				} else {
					this.logisticsList = [];
				}
			} catch (err) {
				console.error('获取物流详情失败:', err);
				this.logisticsList = [];
			}
		},
		backToList() {
			this.showDetail = false;
			this.currentOrder = {};
		},

		getPaymentMethodText(method) {
			if (!method) return '';
			const methodMap = {
				1: '微信支付',
				2: '支付宝',
				3: '对公转账',
				'wechat': '微信支付',
				'alipay': '支付宝',
				'cash': '现金',
				'bank': '银行转账'
			};
			return methodMap[method] || '';
		},
		getFreightTypeText(type) {
			const typeMap = {
				1: '快递运输',
				2: '到付'
			};
			return typeMap[type] || '-';
		},
		grabble() {
			if (this.showDetail && this.currentOrder.pay_no) {
				// 如果在详情页，刷新详情
				this.viewDetail(this.currentOrder);
			} else {
				// 如果在列表页，刷新列表
				this.page = 1;
				this.search();
				this.$emit('refresh-order-nums')
			}
		},
		handleCurrentChange(val) {
			this.page = val;
			this.search();
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				if (this.$refs.height_top) {
					this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100;
				}
			})
		},
		getStateValue(status) {
			const stateMap = {
				'all': '',
				'pending_payment': 0,
				'pending_confirmation': 3,
				'pending_shipment': 20,
				'pending_receipt': 20,
				'completed': 4,
				'cancelled': -1
			};
			return stateMap[status] !== undefined ? stateMap[status] : '';
		},

		async search() {
			this.loading = true;
			try {
				const res = await this.$axios.post('/api/yunsys.Order/getbillslist', {
					state: this.getStateValue(this.status),
					page: this.page,
					ps: this.page_size
				});
				const data = res.data;
				this.loading = false;
				if (data.code !== 0) {
					return ElMessage({
						message: data.msg,
						type: 'error',
						grouping: true
					});
				}
				var obj = this;
				this.total = data.data.total || data.data.length || 0;
				var key = 0;
				const orderList = data.data.data || data.data || [];
				orderList.forEach(item => {
					key = key + 1;
					item.key = (obj.page - 1) * obj.page_size + key;
				});
				this.tableData = orderList;
				// 保存服务器时间
				if (data.data.server_time) {
					this.serverTime = this.parseTimeToSeconds(data.data.server_time);
					this.localTimeAtServerTime = Math.floor(Date.now() / 1000);
				}
			} catch (err) {
				this.loading = false;
				console.error('获取订单列表失败:', err);
				return ElMessage({
					message: '系统错误',
					type: 'error',
					grouping: true
				});
			}
		},
		// 申请开票
		async handleApplyInvoice(order) {
			this.invoiceForm = {
				pay_no: order.pay_no,
				invoice_type: String(order.invoice_type || '1'),
				invoice_title: order.invoice_title || '',
				tax_number: order.tax_number || '',
				phone: order.phone || '',
				address: order.address || '',
				bank_name: order.bank_name || '',
				bank_account: order.bank_account || ''
			};
			this.currentInvoiceInfo.total_order_money = order.total_order_money || 0;
			this.currentInvoiceInfo.total_refund_money = order.total_refund_money || 0;
			this.invoiceFailReason = order.invoice_reason || '';
			this.invoiceDialogVisible = true;
			// 获取开票历史
			await this.fetchInvoiceHistory();
		},
		// 获取开票历史
		async fetchInvoiceHistory() {
			try {
				const res = await this.$axios.post('/api/yunsys.Website/getInvoiceHistory');
				const data = res.data;
				if (data.code === 0) {
					this.invoiceHistoryList = data.data || [];
				} else {
					this.invoiceHistoryList = [];
				}
			} catch (err) {
				console.error('获取开票历史失败:', err);
				this.invoiceHistoryList = [];
			}
		},
		// 选择历史开票信息
		selectInvoiceHistory(item) {
			this.invoiceForm.invoice_title = item.invoice_title;
			this.invoiceForm.tax_number = item.tax_number || '';
			this.invoiceForm.address = item.address || '';
			this.invoiceForm.bank_name = item.bank_name || '';
			this.invoiceForm.bank_account = item.bank_account || '';
			this.invoiceForm.phone = item.phone || '';
		},
		// 查看开票信息
		handleViewInvoiceInfo(order) {
			this.currentInvoiceInfo.invoice_type = order.invoice_type;
			this.currentInvoiceInfo.invoice_title = order.invoice_title || '';
			this.currentInvoiceInfo.tax_number = order.tax_number || '';
			this.currentInvoiceInfo.phone = order.phone || '';
			this.currentInvoiceInfo.address = order.address || '';
			this.currentInvoiceInfo.bank_name = order.bank_name || '';
			this.currentInvoiceInfo.bank_account = order.bank_account || '';
			this.currentInvoiceInfo.total_order_money = order.total_order_money || 0;
			this.currentInvoiceInfo.total_refund_money = order.total_refund_money || 0;

			this.invoiceInfoDialogVisible = true;
		},
		// 查看发票文件
		handleViewInvoiceFile(order) {
			this.currentInvoiceFile = order.invoice_file ? this.$axios.defaults.baseURL + order.invoice_file : '';
			this.currentInvoiceInfo.invoice_type = order.invoice_type;
			this.currentInvoiceInfo.invoice_title = order.invoice_title || '';
			this.currentInvoiceInfo.tax_number = order.tax_number || '';
			this.currentInvoiceInfo.phone = order.phone || '';
			this.currentInvoiceInfo.address = order.address || '';
			this.currentInvoiceInfo.bank_name = order.bank_name || '';
			this.currentInvoiceInfo.bank_account = order.bank_account || '';
			this.currentInvoiceInfo.total_order_money = order.total_order_money || 0;
			this.currentInvoiceInfo.total_refund_money = order.total_refund_money || 0;
			this.currentInvoiceInfo.invoice_number = order.invoice_number || '';
			this.currentInvoiceInfo.invoice_date = order.invoice_date || '';
			this.currentInvoiceInfo.invoice_amount = order.invoice_amount || '';

			this.invoiceFileDialogVisible = true;
		},
		// 打开发票文件（新标签页）
		downloadInvoiceFile() {
			if (!this.currentInvoiceFile) return;
			window.open(this.currentInvoiceFile, '_blank');
		},
		// 下载合同（新标签页打开）
		handleDownloadContract(order) {
			if (!order.htfilepath) return;
			window.open(order.htfilepath, '_blank');
		},
		// 提交开票申请
		async submitInvoice() {
			// 验证可开票金额
			const invoiceAmount = (this.currentInvoiceInfo.total_order_money || 0) - (this.currentInvoiceInfo.total_refund_money || 0);
			if (invoiceAmount <= 0) {
				return ElMessage.error('可开票金额为0，暂不可开票');
			}
			// 验证必填项
			if (!this.invoiceForm.invoice_type) {
				return ElMessage.error('请选择发票类型');
			}
			if (!this.invoiceForm.invoice_title) {
				return ElMessage.error('请输入或选择发票抬头');
			}
			if (this.invoiceForm.invoice_type === '2' && !this.invoiceForm.tax_number) {
				return ElMessage.error('请输入税号');
			}

			this.invoiceSubmitting = true;
			try {
				const res = await this.$axios.post('/api/yunsys.Order/applyInvoice', this.invoiceForm);
				const data = res.data;
				if (data.code === 0) {
					ElMessage.success('开票申请提交成功');
					this.invoiceDialogVisible = false;
					this.invoiceFailReason = '';
					this.search();
				} else {
					ElMessage.error(data.msg || '提交失败');
				}
			} catch (err) {
				console.error('提交开票申请失败:', err);
				ElMessage.error('系统错误');
			} finally {
				this.invoiceSubmitting = false;
			}
		},
		// 启动倒计时定时器
		startCountdownTimer() {
			// 每秒更新一次
			this.countdownTimer = setInterval(() => {
				// 强制重新渲染
				this.$forceUpdate();
			}, 1000);
		},
		// 停止倒计时定时器
		stopCountdownTimer() {
			if (this.countdownTimer) {
				clearInterval(this.countdownTimer);
				this.countdownTimer = null;
			}
		}

	}
}
</script>
<style lang="less" scoped>
.step-icon-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 26px;
	transition: all 0.3s ease;
}

.step-time {
	font-size: 12px;
	color: #999;
}

.order-progress-section {
	padding: 30px 20px;
}

.progress-steps {
	padding: 10px 0;
	width: 100%;
	overflow-x: auto;
}



.ship-info {
	background: linear-gradient(135deg, #fff5f0 0%, #ffe4d6 100%);
	border-radius: 12px;
	padding: 20px;
	border: 1px solid #ffd4c2;
}

.ship-title {
	font-size: 16px;
	font-weight: 600;
	color: #ff6b35;
	margin-bottom: 16px;
	display: flex;
	align-items: center;
	gap: 8px;
}

.ship-title::before {
	content: '';
	width: 4px;
	height: 16px;
	background: #ff8a5c;
	border-radius: 2px;
}

.ship-detail {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
}

.detail-item {
	flex: 1;
	min-width: 200px;
	display: flex;
	align-items: flex-start;
}

.detail-item.full-width {
	flex: 1 1 100%;
}

.detail-label {
	font-size: 14px;
	color: #666;
	white-space: nowrap;
	min-width: 80px;
}

.detail-value {
	font-size: 14px;
	color: #333;
	font-weight: 500;
	word-break: break-all;
}

// :deep(.el-step__title.is-process) {
// 	color: #ff8a5c !important;
// }

// :deep(.el-step__head.is-process) {
// 	color: #ff8a5c !important;
// }

:deep(.el-step__title.is-success) {
	color: #ff8a5c !important;
}

:deep(.el-step__head.is-success) {
	color: #ff8a5c !important;
}

:deep(.el-steps .el-step__line.is-wait) {
	background-color: #e5e5e5;
}

:deep(.el-steps .el-step__line.is-finish) {
	background-color: #ff8a5c;
}

:deep(.el-steps .el-step__icon.is-finish) {
	border-color: #ff8a5c;
	background-color: #ff8a5c;
	color: #fff;
}

:deep(.el-steps .el-step__icon.is-finish .step-icon-wrapper) {
	background-color: #ff8a5c;
	border-color: #ff8a5c;
	color: #fff;
}

:deep(.el-steps .el-step__icon.is-process) {
	border-color: #ff8a5c;
	background-color: #fff;
}

:deep(.el-steps .el-step__icon.is-process .step-icon-wrapper) {
	border-color: #ff8a5c;
	background: linear-gradient(135deg, #fff5f0 0%, #ffe4d6 100%);
	color: #ff8a5c;
}

:deep(.el-steps .el-step__title.is-finish) {
	color: #ff8a5c;
}

:deep(.el-timeline-item__timestamp.is-top) {
	font-size: 12px;
	color: #666;
}

.status-tag {
	width: max-content;
	font-size: 13px;
	padding: 13px 10px;
}

/* 修改为固定在订单容器底部 */
.order-container {
	position: relative;
	// padding-bottom: 60px; /* 为底部栏预留空间 */
}

.order-detail-footer {
	position: sticky;
	bottom: 0;
	z-index: 100;
	background: #fff;
	border-top: 1px solid #e5e5e5;
	padding: 12px 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
	z-index: 100;
}

.footer-left {
	display: flex;
	gap: 30px;
}

.total-info {
	display: flex;
	align-items: center;
}

.total-label {
	font-size: 14px;
	color: #666;
}

.total-value {
	font-size: 14px;
	color: #333;
}

.total-amount {
	font-size: 18px;
	font-weight: 600;
	color: #ff8a5c;
}

.footer-right {
	display: flex;
	gap: 10px;
}

.delete-btn {
	padding: 8px 24px;
	font-size: 14px;
	background: #fff;
	border: 1px solid #ff8a5c;
	color: #ff8a5c;
	border-radius: 4px;
	transition: all 0.3s ease;
}

.delete-btn:hover {
	background: #fff5f0;
}



/* 滚动条样式优化 */
/* Firefox 滚动条样式 */
:deep(.scroll-container) {
	scrollbar-width: thin;
	scrollbar-color: transparent transparent;
	transition: scrollbar-color 0.2s ease;
}

:deep(.scroll-container:hover) {
	scrollbar-color: #c9cdd4 transparent;
}

/* Chrome/Safari 滚动条样式 */
:deep(.scroll-container::-webkit-scrollbar) {
	width: 6px;
	height: 6px;
}

:deep(.scroll-container::-webkit-scrollbar-thumb) {
	background-color: #e5e6eb;
	border-radius: 6px;
	opacity: 0;
	transition: all 0.2s ease;
}

:deep(.scroll-container:hover::-webkit-scrollbar-thumb) {
	opacity: 1;
	background-color: #c9cdd4;
}

:deep(.scroll-container::-webkit-scrollbar-track) {
	background: transparent;
}

/* 详情页样式 */
.detail-header {
	padding-bottom: 10px;
	padding-top: 10px;
}

.price-value {
	color: #ff8a5c;
	font-weight: 600;
}

/* 以下是从订单详情页复制的样式 */
.order-detail-page {
	background: #f5f7fa;
	padding: 10px 5px 0px 4px;
}



.order-section {
	background: #fff;
	border-radius: 12px;
	padding: 24px;
	margin-bottom: 16px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.section-title {
	font-size: 16px;
	font-weight: 600;
	color: #333;
	padding-bottom: 12px;
	display: flex;
	align-items: center;

	&::before {
		content: '';
		display: inline-block;
		width: 4px;
		height: 16px;
		background: linear-gradient(135deg, #ff8a5c 0%, #ff6b3d 100%);
		border-radius: 2px;
		margin-right: 10px;
	}
}

.order-info {
	background: linear-gradient(135deg, #fff5f0 0%, #fff 100%);
	padding: 16px;
	border-radius: 8px;
	border: 1px solid #ffe4d6;
}

.info-item {
	font-size: 14px;
	//margin-bottom: 8px;
	line-height: 20px;

	&:last-child {
		margin-bottom: 0;
	}
}

.info-label {
	color: #666;
	margin-right: 8px;
}

.info-value {
	color: #ff8a5c;
	font-weight: 600;
	font-family: 'Courier New', monospace;
}

.order-section-row {
	display: flex;
	gap: 32px;
}

.order-section-col {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
}

.order-section-col .order-info {
	flex: 1;
}

.voucher-info-item {
	display: flex;
	align-items: flex-start;
}

.voucher-list {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-top: 4px;
}

.voucher-img {
	width: 20px;
	height: 20px;
	border-radius: 4px;
	overflow: hidden;
	flex-shrink: 0;
}

.address-section {
	.address-item {
		padding: 16px;
		border: 2px solid #e8e8e8;
		border-radius: 8px;
		background: #fafafa;
	}

	.address-info {
		margin-bottom: 8px;
	}

	.address-name {
		font-weight: 600;
		color: #333;
		margin-right: 12px;
	}

	.address-phone {
		color: #666;
	}

	.address-detail {
		color: #666;
		font-size: 14px;
	}
}

.remark-section {
	.remark-content {
		padding: 12px;
		background: #fafafa;
		border-radius: 8px;
		border: 1px solid #e5e5e5;
		color: #333;
		font-size: 14px;
	}
}

.order-summary {
	.summary-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 8px 0;
		font-size: 14px;
	}

	.summary-label {
		color: #666;
	}

	.summary-value {
		color: #333;
	}

	.summary-divider {
		height: 1px;
		background: #e8e8e8;
		margin: 8px 0;
	}

	.total-item {
		padding-top: 12px;
		font-size: 16px;
	}

	.total-value {
		color: #ff8a5c;
		font-weight: 700;
		font-size: 20px;
	}

	.discount {
		color: #ff4d4f;
		font-weight: 700;
		font-size: 16px;
		display: flex;
		align-items: center;
		gap: 4px;

		.el-tag {
			font-size: 11px;
			padding: 0 6px;
			height: 20px;
			line-height: 20px;
			border-radius: 3px;
		}
	}
}



.brand-name {
	font-weight: 600;
	color: #333;
	margin-bottom: 4px;
}

.product-name {
	color: #333;
	margin-bottom: 4px;
}

.product-details {
	color: #666;
	font-size: 13px;
}

.detail-label {
	color: #999;
}

.label-colon {
	margin: 0 4px;
}

.detail-value {
	color: #333;
}

.stock_type_txt_button .el-button {
	margin-right: 5px;
	font-size: 0.70rem !important;
	padding: 0.2525rem 0.5875rem;
}

.stock_type_txt_button .A {
	color: #ff8a5c;
	background-color: rgb(255, 240, 228) !important;
}

.stock_type_txt_button .C {
	color: rgb(75, 212, 205);
	background-color: rgb(223, 255, 251) !important;
}

:deep(.purchase-list .el-image) {
	border-radius: 3px;
	height: 100px;
	width: 100px;
	display: inline-block;
	display: flex;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
	background-color: #ff8a5c;
}

/* 订单卡片列表样式 */
.order-card-container {
	background: #f5f7fa;
	padding: 6px 6px 5px 6px;
}

.order-card-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.order-card {
	background: #fff;
	border-radius: 8px;
	padding: 8px 12px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
	transition: all 0.3s ease;
}

.order-card:hover {
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
	transform: translateY(-2px);
}

.card-header {
	//display: flex;
	gap: 16px;
	padding-bottom: 6px;
	border-bottom: 1px solid #f0f0f0;
	margin-bottom: 8px;
	align-items: center;
}



.confirm-tip {
	margin-left: auto;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 2px 8px;
	background: linear-gradient(135deg, #fff7e6 0%, #fff 100%);
	border: 1px solid #ffd591;
	border-radius: 4px;
	color: #fa8c16;
	font-size: 11px;
	font-weight: 500;
	animation: pulse 2s infinite;
}

@keyframes pulse {

	0%,
	100% {
		opacity: 1;
	}

	50% {
		opacity: 0.8;
	}
}

.confirm-tip {
	display: flex;
	align-items: center;
	gap: 4px;
	margin-left: auto;
	flex-shrink: 0;
	font-size: 12px;
	color: #ff8a5c;
	background: #fff5f0;
	padding: 4px 10px;
	border-radius: 4px;
}

.header-item {
	display: flex;
	flex-direction: column;
	gap: 1px;
	line-height: 1.5;
}

.item-label {
	font-size: 11px;
	color: #999;
}

.item-value {
	font-size: 13px;
	color: #333;
}

.order-no {
	font-family: 'Courier New', monospace;
	font-weight: 600;
}

.card-body {
	// display: flex;
	// justify-content: space-between;
	// align-items: center;
}

.body-left {
	// display: flex;
	// flex-direction: column;
	// gap: 6px;
}

.info-row {
	// display: flex;
	// gap: 24px;
	// flex-wrap: wrap;
	// align-items: center;
}

.info-item {
	display: flex;
	flex-direction: column;
	gap: 1px;
}

.status-info-item {
	flex-direction: row;
	align-items: center;
}

.cancel-reason-icon {
	font-size: 16px;
	color: #ff8a5c;
	vertical-align: middle;
	cursor: help;
}

.info-label {
	font-size: 11px;
	color: #999;
}

.info-value {
	font-size: 13px;
	color: #333;
}

.price {
	color: #ff8a5c;
	font-weight: 700;
}

.discount {
	color: #ff4d4f;
	font-weight: 700;
	font-size: 16px;
	display: flex;
	align-items: center;
	gap: 4px;
}

.discount .el-tag {
	font-size: 11px;
	padding: 0 6px;
	height: 20px;
	line-height: 20px;
	border-radius: 3px;
}

.status-item {
	display: flex;
	align-items: center;
}

.body-right {
	display: flex;
	gap: 16px;
	align-items: center;
	justify-content: flex-end;
}

.order-amount-wrapper {
	display: flex;
	flex-direction: column;
	gap: 1px;
	line-height: 1.4;
	margin-right: 20px;
	width: 120px;
	flex-shrink: 0;
}

.order-amount-label {
	font-size: 11px;
	color: #999;
}

.order-amount-value {
	font-size: 16px;
	font-weight: 700;
	color: #ff8a5c;
}

.button-group {
	display: flex;
	gap: 6px;
	min-width: 520px;
	justify-content: flex-end;
	align-items: center;
}

.countdown-wrapper {
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 4px 10px;
	background: linear-gradient(135deg, #fff7e6 0%, #fff 100%);
	border: 1px solid #ffd591;
	border-radius: 4px;
	margin-right: 10px;
	flex-shrink: 0;
}

.countdown-text {
	font-size: 12px;
	color: #fa8c16;
	font-weight: 500;
	white-space: nowrap;
}

/* 小屏幕 (平板, 768px 及以上) */
@media (min-width: 768px) {
	.search_remark {
		width: 120px;
	}
}

/* 中等屏幕 (桌面, 992px 及以上) */
@media (min-width: 992px) {
	.search_remark {
		width: 170px;
	}
}

/* 大屏幕 (大桌面, 1600px 及以上) */
@media (min-width: 1600px) {
	.search_remark {
		width: 400px;
		margin-left: 60px
	}
}

/* 超大屏幕 (更大桌面, 1920px 及以上) */
@media (min-width: 1920px) {
	.search_remark {
		width: 400px;
		margin-left: 60px
	}
}

/* 滚动条样式优化 */
/* Firefox 滚动条样式 */
:deep(.order-card-container) {
	scrollbar-width: thin;
	scrollbar-color: transparent transparent;
	transition: scrollbar-color 0.2s ease;
}

:deep(.order-card-container:hover) {
	scrollbar-color: #c9cdd4 transparent;
}

/* Chrome/Safari 滚动条样式 */
:deep(.order-card-container::-webkit-scrollbar) {
	width: 6px;
	height: 6px;
}

:deep(.order-card-container::-webkit-scrollbar-thumb) {
	background-color: #e5e6eb;
	border-radius: 6px;
	opacity: 0;
	transition: all 0.2s ease;
}

:deep(.order-card-container:hover::-webkit-scrollbar-thumb) {
	opacity: 1;
	background-color: #c9cdd4;
}

:deep(.order-card-container::-webkit-scrollbar-track) {
	background: transparent;
}
</style>